import { RequestFullscreenMessage } from "../../messages/media";
import { busService } from "../../modules/bus";
import { remoteStreamingService, StreamType } from "../../modules/multiplayer/peer/RemoteStreamingService";
import { create } from "zustand";
export const useRemoteVideoStreamsStore = create((set) => ({
    remoteScreenStreams: [],
    setRemoteScreenStreams(remoteScreenStreams) {
        set({ remoteScreenStreams });
    },
    remoteCameraStreams: [],
    setRemoteCameraStreams(remoteCameraStreams) {
        set({ remoteCameraStreams });
    },
    openedScreenStream: undefined,
    setOpenedScreenStream: (openedScreenStream) => {
        set({ openedScreenStream });
    }
}));
busService.connection("Remote Video Streams Store").subscribeByType(RequestFullscreenMessage, (msg) => {
    const remoteStream = remoteStreamingService.getScreenStreams().find((s) => s.type === StreamType.screen && s.surfaceUid === msg.surfaceUid);
    if (remoteStream && remoteStream.type === StreamType.screen) {
        useRemoteVideoStreamsStore.getState().setOpenedScreenStream({
            stream: remoteStream.stream,
            clientId: remoteStream.clientId,
            surfaceUid: remoteStream.surfaceUid,
            streamType: "screen"
        });
    }
});
function getVideoStreamsFromService() {
    const cameraStreams = remoteStreamingService.getCameraStreams().map((remoteStream) => ({
        stream: remoteStream.stream,
        clientId: remoteStream.clientId,
        streamType: "camera"
    }));
    useRemoteVideoStreamsStore.getState().setRemoteCameraStreams(cameraStreams);
    const screenStreams = remoteStreamingService.getScreenStreams().map((remoteStream) => ({
        stream: remoteStream.stream,
        clientId: remoteStream.clientId,
        surfaceUid: remoteStream.type === StreamType.screen ? remoteStream.surfaceUid : undefined,
        streamType: "screen"
    }));
    const player3DViewStreams = remoteStreamingService.getPlayer3dViewStreams().map((remoteStream) => ({
        stream: remoteStream.stream,
        clientId: remoteStream.clientId,
        surfaceUid: remoteStream.surfaceUid,
        streamType: "screen"
    }));
    // Ensure all screen streams have a surfaceUid and remove the stream if not
    screenStreams.push(...player3DViewStreams);
    screenStreams.forEach((screenStream) => {
        if (screenStream.surfaceUid === undefined) {
            console.error("[ui] Screen stream without surfaceUid", screenStream);
            screenStreams.splice(screenStreams.indexOf(screenStream), 1);
        }
    });
    useRemoteVideoStreamsStore.getState().setRemoteScreenStreams(screenStreams);
    // Remove opened stream if it is not in the list anymore
    const openedScreenStream = useRemoteVideoStreamsStore.getState().openedScreenStream;
    if (openedScreenStream) {
        const allStreams = [...screenStreams, ...cameraStreams];
        if (!allStreams.find((stream) => stream.stream.id === openedScreenStream.stream.id)) {
            useRemoteVideoStreamsStore.getState().setOpenedScreenStream(undefined);
        }
    }
}
getVideoStreamsFromService();
remoteStreamingService.onUpdateDelegate.add(getVideoStreamsFromService);
setTimeout(getVideoStreamsFromService, 5000);
